<template>
  <div class="col">
    <div
      v-if="pending"
      class="row first justify-center"
    >
      <h2>Chargement</h2>
    </div>
    <div
      v-if="!pending"
      class="row first"
    >
      <div
        v-if="coin"
        class="col"
      >
        <div class="row">
          <div class="col">
            <h1>{{ coin.name }}</h1>
          </div>
          <div
            v-if="isAuthenticated"
            class="col collection justify-center"
          >
            <div
              v-if="!existInCollection"
              class="row"
            >
              <div class="button-wrapper">
                <custom-button
                  :loading="addPending"
                  @click.native="addToCollection"
                >
                  <i class="fas fa-plus"></i>
                  Ajouter à ma collection
                </custom-button>
              </div>
            </div>
            <div
              v-if="existInCollection"
              class="row"
            >
              <h3>Cette pièce est dans votre collection.</h3>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="row">
              <h3>Informations complémentaires</h3>
            </div>
            <div class="row">
              Valeur : {{ coin.value }}
            </div>
            <div class="row">
              Période : {{ coin.yearsRange }}
            </div>
            <div class="row">
              Pays d'origine : {{ coin.country }}
            </div>
            <div class="row">
              Index de rareté : {{ coin.rarity }}
            </div>
            <div class="row">
              Matière : {{ translate(coin.metal) }}
            </div>
            <div class="row">
              Forme : {{ translate(coin.shape) }}
            </div>
            <div class="row">
              Poids : {{ coin.weight }}
            </div>
            <div class="row">
              Prix moyen :&nbsp;<span v-if="price != null">{{ price }}</span><span
                v-if="price === null"
              ><spinner></spinner></span>
            </div>
          </div>
          <div class="col">
            <div class="row images">
              <img
                class="coin-face"
                :src="coin.images.obverse"
                alt="Côté Pile"
              >
              <img
                class="coin-face"
                :src="coin.images.reverse"
                alt="Côté Face"
              >
            </div>
            <div class="row justify-center">
              {{ coin.images.copyright }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!coin"
        class="col"
      >
        <div class="row justify-center">
          <error-message>Aucun élément de correspond à l'id : "{{ coinId }}"</error-message>
        </div>
        <div class="row error-btn justify-center">
          <custom-button @click.native="goToSearchPage">
            <span class="fas fa-arrow-left"></span>
            Retour à la page de recherche
          </custom-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CustomButton from './micro-components/custom-button';
  import FirebaseCollection from './../tools/FirebaseCollection';
  import Translater from './../tools/Translater';
  import NumistaAPI from './../tools/NumistaAPI';
  import Spinner from './micro-components/spinner';
  import store from './../stores';
  import ErrorMessage from './micro-components/error-message';

  export default {
    name: 'CoinDetails',
    components: { ErrorMessage, Spinner, CustomButton },
    data() {
      return {
        coin: null,
        pending: true,
        price: null,
        addPending: false,
        existInCollection: false,
        coinId: null,
      };
    },
    computed: {
      isAuthenticated() {
        return store.state.auth.isAuthenticated;
      },
      collectionChange() {
        return store.state.collection.change;
      }
    },
    watch: {
      collectionChange() {
        this.existInCollection = !!store.getters.getCoinById(this.coinId);
      }
    },
    created() {
      const { id } = this.$route.params;
      NumistaAPI.getDetails(id)
        .then(coin => {
          this.coin = FirebaseCollection.parseCoin(coin);
          this.pending = false;
        })
        .catch(() => {
          this.pending = false;
        });
      NumistaAPI.getPrice(id)
        .then(({ prices }) => {
          this.price = `${prices[0].average} €`;
        })
        .catch(() => {
          this.price = 'Indisponible';
        });

      this.coinId = parseInt(id, 10);
      this.existInCollection = !!store.getters.getCoinById(this.coinId);
    },
    methods: {
      goToSearchPage() {
        this.$router.push({ name: 'search-by-id' });
      },
      translate(text) {
        return Translater.translate(text);
      },
      async addToCollection() {
        this.addPending = true;
        await FirebaseCollection.addCoin(this.coin);
        this.addPending = false;
      },
    }
  };
</script>

<style scoped>
    h1, h2, h3 {
        margin: 0;
    }

    .coin-face {
        width: 100%;
        max-width: 250px;
        height: auto;
        max-height: 250px;
    }

    .col {
        width: 100%;
    }

    .button-wrapper {
        max-width: 250px;
        padding-right: 1em;
    }

    .first {
        margin-top: 0;
    }

    .images {
        justify-content: space-around;
    }

    .error-btn {
        margin-top: 1em;
    }

    .collection .row {
        width: 100%;
        justify-content: flex-end;
    }
</style>
